import { ProfileDd } from '../../../interfaces';
import { APP_ROUTES } from '../../routes';

export const profileDd: ProfileDd[] = [
    // { title: 'Edit Profile', icon: 'ft-edit', path: APP_ROUTES.root, clickable: false },
    { title: 'Logout', icon: 'ft-power', path: '', clickable: true }
]